module.exports = {
      id: "ic-linebreak-normal-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "sprite-dbc6d5.smartcharts.svg#ic-linebreak-normal-usage",
      toString: function () {
        return this.url;
      }
    }